import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useRepo from '@/nebula/repo';
import { computed } from 'vue';
import { mSTeamsConfiguration as mSTeamsConfigurationConfig } from 'shared/api/query/configs.json';

export default function useMSTeamsConfiguration() {
  const repo = useRepo(mSTeamsConfigurationConfig.model);
  const { loggedInUser } = useLoggedInUser();

  const msTeamsConfiguration = computed(() => {
    if (loggedInUser.value === null || loggedInUser.value.msTeamsConfiguration === null) {
      return null;
    }

    return repo.selectSingle(loggedInUser.value.msTeamsConfiguration?.uid);
  });

  return {
    msTeamsConfiguration,
    createSingle: repo.createSingle,
    updateSingle: repo.updateSingle,
  };
}
